module.exports = __webpack_public_path__ + "media/bootstrap-icons/hexagon-fill-83b83d07.svg";